<app-topmenu
  [courseName]="configuration?.courseName"
  [menu]="configuration?.menu"
  [nextDecision]="nextDecision"
></app-topmenu>
<app-header
  [pageName]="title"
  [pageClass]="'markets'"
  [data]="subMenu"
></app-header>
<div class="container" id="main-content">
  <app-submenu [data]="subMenu" [isWhiteLine]="false"></app-submenu>
</div>
<hr class="hr-white" />
<div class="container">
  <app-zonepanel [zones]="zones"></app-zonepanel>
</div>
<app-dialog #dialog></app-dialog>
<app-footer></app-footer>
<app-needhelp-button [token]="token" *ngIf="token"></app-needhelp-button>
